import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TeamShortModal } from "app/components";
import { DrawingClubWCGroupBasketsDto, DrawingclubWCGroupStageResultDto, GroupDto, TeamShortDto } from "app/models";
import { DrawingsService, NotificationService } from "app/services";

@Component({
    selector: 'admin-club-world-cup-group',
    templateUrl: 'club-world-cup-group.page.html',
    styleUrls: ['club-world-cup-group.page.scss'],
})
export class AdminDrawingClubWorldCupGroup implements OnInit {
    
    groupBaskets: DrawingClubWCGroupBasketsDto;

    isLoading: boolean = false;

    ratings: number[];

    drawingResult: DrawingclubWCGroupStageResultDto;

    formGroup: FormGroup;

    constructor (private drawingService: DrawingsService, private modalService: NgbModal,
         private notificationService: NotificationService) {

    }
    
    ngOnInit(): void {
        this.loadGroupBaskets();
        this.buildFormGroup();
    }

    onAddTeam(basketNumber: number) {
        const modalRef = this.modalService.open(TeamShortModal);
    
        modalRef.componentInstance.team = null;
    
        let basket: TeamShortDto[] = [];
    
            switch (basketNumber) {
                case 1:
                    basket = this.groupBaskets.basket1;
                    break;
    
                case 2:
                    basket = this.groupBaskets.basket2;
                    break;
    
                case 3:
                    basket = this.groupBaskets.basket3;
                    break;
    
                case 4:
                    basket = this.groupBaskets.basket4;
                    break;
            }
    
            modalRef.result.then((result) => {
                if (result) {
                    basket.push(result);
                }
           }, (reason) => { });
         }

    onChangeTeam(team: number, basketNumber: number, index: number) {
        const modalRef = this.modalService.open(TeamShortModal);

        modalRef.componentInstance.team = team;

        let basket: TeamShortDto[] = [];

        switch (basketNumber) {
            case 1:
                basket = this.groupBaskets.basket1;
                break;

            case 2:
                basket = this.groupBaskets.basket2;
                break;

            case 3:
                basket = this.groupBaskets.basket3;
                break;

            case 4:
                basket = this.groupBaskets.basket4;
                break;
        }

        modalRef.result.then((result) => {
            if (result) {
                basket[index] = result;
            }
        }, (reason) => { });
    }

    getTeamRating(teamId: number): number {
        return this.ratings[teamId];
    }

    doDraw() {
        if (!this.formGroup.controls.md1FormControl.value || !this.formGroup.controls.md2FormControl.value || !this.formGroup.controls.md3FormControl.value) {
            this.notificationService.showError('На заполенены ИД');
            
            return;
        }

        let mds: number[] = [this.formGroup.controls.md1FormControl.value, this.formGroup.controls.md2FormControl.value, this.formGroup.controls.md3FormControl.value] 


        this.drawingService.drawClubWCGroupStage(this.groupBaskets, mds)
            .subscribe(result => {
                this.drawingResult = result;
                this.notificationService.showSuccess('Жеребьевка проведена успешно');
            }, error => {
                this.notificationService.showError('Ошибка жеребьевки.');
            })
    }


    private loadGroupBaskets() {
        this.isLoading = true;
        this.drawingService.getClubWCGroupBaskets()
            .subscribe(result => {
                this.groupBaskets = result;

                this.ratings = [];

                result.ratings.forEach(item => {
                    this.ratings[item.teamId] = item.rating;
                })

                this.isLoading = false;
            })
    }

    private buildFormGroup() {
        this.formGroup = new FormGroup({
            md1FormControl: new FormControl(),
            md2FormControl: new FormControl(),
            md3FormControl: new FormControl(),
        });
    }
}